import React from "react";
import coneSvg from "@assets/svg/cone.svg";
import { Heading } from "@foris/avocado-suite";
import styles from "./tenantNotFound.module.scss";

interface TenantNotFoundProps {
  title?: string;
  children?: React.ReactNode;
}

const TenantNotFound = ({ title, children }: TenantNotFoundProps) => {
  return (
    <main className={styles.errorBody}>
      <img src={coneSvg} />
      <section className={styles.errorBody_content}>
        <Heading type="h1">{title}</Heading>

        <div className={styles.description}>{children}</div>
      </section>
    </main>
  );
};

export default TenantNotFound;
